/**
 * Formata um valor em moeda brasileira (BRL)
 * @param {number} valor - Valor a ser formatado
 * @returns {string} Valor formatado em BRL
 */
export const formatarMoeda = (valor) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);
};

/**
 * Formata uma data
 * @param {string} data - Data no formato DD/MM/YYYY ou ISO
 * @returns {string} Data formatada
 */
export const formatarData = (data) => {
  if (!data) return '-';
  
  // Se a data já está no formato DD/MM/YYYY, retornar como está
  if (data.includes('/')) {
    return data;
  }
  
  // Parsear data ISO (YYYY-MM-DD) manualmente para evitar problemas de timezone
  const matchIso = data.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (matchIso) {
    // Retornar no formato DD/MM/YYYY sem conversão de timezone
    return `${matchIso[3]}/${matchIso[2]}/${matchIso[1]}`;
  }
  
  // Fallback: tentar parsear como Date (pode ter problemas de timezone)
  try {
    return new Date(data).toLocaleDateString('pt-BR');
  } catch {
    return data;
  }
};

